import React from 'react';

interface NavigationPanelProps {
  allSubmissions: any[];
  currentSubmissionIndex: number;
  onNavigateToSubmission: (index: number) => void;
}

const NavigationPanel: React.FC<NavigationPanelProps> = ({
  allSubmissions,
  currentSubmissionIndex,
  onNavigateToSubmission,
}) => {
  if (!allSubmissions || allSubmissions.length <= 1) return null;

  return (
    <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-4 mt-6">
      <div className="flex items-center justify-center gap-4">
        {/* Previous Button */}
        <button
          onClick={() => onNavigateToSubmission(currentSubmissionIndex - 1)}
          className="flex items-center gap-2 px-6 py-3 text-sm font-medium font-baijamjuree rounded-full transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200"
          title={`Previous submission (← key)${currentSubmissionIndex === 0 ? ' - loops to last' : ''}`}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Previous
        </button>

        {/* Submission Counter */}
        <div className="px-4 py-2 bg-blue-50 rounded-full border border-blue-200">
          <span className="text-sm font-semibold text-blue-800 font-baijamjuree">
            {currentSubmissionIndex + 1} / {allSubmissions.length}
          </span>
        </div>

        {/* Next Button */}
        <button
          onClick={() => onNavigateToSubmission(currentSubmissionIndex + 1)}
          className="flex items-center gap-2 px-6 py-3 text-sm font-medium font-baijamjuree rounded-full transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200"
          title={`Next submission (→ key)${currentSubmissionIndex === allSubmissions.length - 1 ? ' - loops to first' : ''}`}
        >
          Next
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default NavigationPanel;
